export type ICashbackMissingClaimFormResources = typeof CashbackMissingClaimFormResources;

export const CashbackMissingClaimFormResources = {
    visaChannelTitle: "Zakup",
    offlineChannel: "Offline",
    onlineChannel: "Online",
    transactionDateLabel: "Data złożenia zamówienia:",
    transactionDatePlaceholder: "dzień . miesiąc . rok",
};
